import { ITranslation } from "sierra";

export const isTranslation = (value: ITranslation) => {
    return Object.keys(value).every(k => ["en", "ar", "zh"].some(l => l == k)) && Object.values(value).some(v => v?.length > 3)
};
